/** Class strings shared by several chat components. Compose with `cn()`. */

/** Ghost/outline buttons restate the hover colours so dark mode matches light. */
export const HOVER_MUTED =
  "hover:bg-muted motion-reduce:transition-none dark:hover:bg-muted";

export const HOVER_MUTED_TEXT = `hover:text-foreground ${HOVER_MUTED}`;

export const HOVER_CARD =
  "hover:bg-card/70 hover:text-foreground motion-reduce:transition-none dark:hover:bg-card/70";

export const HEADER_ICON_CLASS =
  "min-h-11 min-w-11 shrink-0 cursor-pointer rounded-full text-muted-foreground hover:bg-muted hover:text-foreground motion-reduce:transition-none dark:hover:bg-muted";

export const ERROR_CLASS =
  "flex shrink-0 items-center gap-2 bg-destructive/15 px-3 py-2 text-xs text-foreground";
